// src/utils/translations/ResetPasswordPageTranslations.js
const translations = {
  fr: {
    title: "Définir un nouveau mot de passe",
    success: "Mot de passe mis à jour avec succès.",
    invalidOrExpired: "Demande invalide ou expirée.",
    errorGeneric: "Une erreur s'est produite.",
    errorReset: "Erreur lors de la réinitialisation du mot de passe.",
    loginCta: "Me connecter"
  },
  en: {
    title: "Set a new password",
    success: "Password updated successfully.",
    invalidOrExpired: "Invalid or expired request.",
    errorGeneric: "An error occurred.",
    errorReset: "Error while resetting the password.",
    loginCta: "Log in"
  },
  de: {
    title: "Neues Passwort festlegen",
    success: "Passwort erfolgreich aktualisiert.",
    invalidOrExpired: "Ungültige oder abgelaufene Anfrage.",
    errorGeneric: "Es ist ein Fehler aufgetreten.",
    errorReset: "Fehler beim Zurücksetzen des Passworts.",
    loginCta: "Anmelden"
  },
  es: {
    title: "Definir una nueva contraseña",
    success: "Contraseña actualizada correctamente.",
    invalidOrExpired: "Solicitud inválida o caducada.",
    errorGeneric: "Se ha producido un error.",
    errorReset: "Error al restablecer la contraseña.",
    loginCta: "Iniciar sesión"
  },
  it: {
    title: "Imposta una nuova password",
    success: "Password aggiornata con successo.",
    invalidOrExpired: "Richiesta non valida o scaduta.",
    errorGeneric: "Si è verificato un errore.",
    errorReset: "Errore durante il reset della password.",
    loginCta: "Accedi"
  }
};

export default translations;